import "../styles/basket-row.css";
import { useState } from "react";
import { BasketContext } from "../contexts/BasketContexts";
import { useContext } from "react";
import { Link } from 'react-router-dom'

export const BasketRow = ({ movie, qty }) => {
  const { setBasket } = useContext(BasketContext);
 
  //calculations for updating the subtotal
  const subTotalNum = movie.price * qty;
  const subTotalDec = subTotalNum.toFixed(2);

  //increment button for items in basket, with limit for no stock
  const increment = () => {
    if (movie.stock <= qty) {
      return 
    }
    setBasket((basket) => {
      return [...basket, movie];
    }
    );
  };

//decrement button for items in basket
  const decrement = () => {
    setBasket((basket) => {
    const index = basket.findLastIndex(match => match.title === movie.title)
    const _= basket.splice(index,1)
    return [...basket]
  
  })
};

// tooltip for low stock
const tooltip = `${movie.imdbID}-tooltip`;

if (movie.stock <= qty)
{
    window.$(`#${tooltip}`).tooltip("enable");
}

// html code for basket rows
  return (
    <div className="basket-row">
      <div className="col-3 item-title">
        <p className="title"> {movie.title} </p>
      </div>
      <div className="col-4 item-poster">
      <img src={movie.poster} alt="poster" className="poster" />
      </div>
      <div className="item-qty col-3">
        {movie.stock === qty
        ? <i className="bi bi-plus-lg" id={tooltip} data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title={`Not enough stock`}></i>
        : <i className="bi bi-plus-lg" onClick={increment}></i>
      }
        <p>{qty}</p>
        <i className="bi bi-dash-lg" onClick={decrement}></i>
      </div>
      <div className="item-subtotal col-2">
      <p>{subTotalDec}</p>
      </div>
    </div>
  );
};
